import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase";
import 'firebase/firestore';
import VModal from 'vue-js-modal';
 
Vue.use(VModal, { dialog: true })


Vue.config.productionTip = false;
Vue.prototype.$speakeasy = require('speakeasy')
Vue.prototype.$QRCode = require('qrcode');

new Vue({
  router,
  store,
  render: h => h(App),
  created: () => {
    firebase.initializeApp({
      apiKey: "AIzaSyAygUgJxJ6vgZ3VDD9e7QzzoTlJruRTtRQ",
      authDomain: "kellner-a9420.firebaseapp.com",
      databaseURL: "https://kellner-a9420.firebaseio.com",
      projectId: "kellner-a9420",
      storageBucket: "kellner-a9420.appspot.com",
      messagingSenderId: "746456615330",
      appId: "1:746456615330:web:3a14c6cbaab9fc72bd0afb"
    });
  }
}).$mount("#app");
